import $ from 'jquery';

export default class Form {

    static serializeObject(element: any, options?: { verifyEmpty: boolean }) {
        let form = $(element);

        if (!form.is('form')) {
            form = $('<form/>').append(form.clone());
        }

        const obj: any = {};
        const arr = form.serializeArray();

        for (let i = 0; i < arr.length; i++) {
            const name = arr[i].name;
            const value = arr[i].value;

            // Ignorar campos mobile para evitar duplicação
            if (name.includes('Mobile')) {
                continue;
            }

            if (obj[name] !== undefined) {
                if (!Array.isArray(obj[name]))
                    obj[name] = [obj[name]];

                obj[name].push(value);
            } else
                obj[name] = value;
        }

        form.find('.uk-form-controls').find('input, select, textarea').trigger('input');
        obj.isValid = !form.find('.uk-form-controls.error').length;

        if (!options)
            return obj;

        obj.length = arr.length;

        if (options.verifyEmpty) {
            let focused = false;
            for (const prop in obj) {
                if (!obj[prop].toString().trim()) {
                    obj.emptyLength = (obj.emptyLength || 0) + 1;

                    const input = form.find(`[name="${prop}"]`);
                    if (input.is('.required:visible')) {
                        obj.requiredEmptyLength = (obj.requiredEmptyLength || 0) + 1;

                        if (!focused) {
                            input.focus();
                            focused = true;
                        }
                    }
                }
            }
        }

        return obj;
    }

    static serializeObjectFormated(element: any): any {
        const result: any = {};
        const arrays: Record<string, any[]> = {};

        var data = Form.serializeObject(element);
        for (const [key, value] of Object.entries(data)) {
            const match = key.match(/^(\w+)\[(\d+)]\.(\w+)$/);

            if (match) {
                const [, arrayName, index, prop] = match;
                const idx = parseInt(index);

                if (!arrays[arrayName])
                    arrays[arrayName] = [];

                if (!arrays[arrayName][idx])
                    arrays[arrayName][idx] = {};

                arrays[arrayName][idx][prop] = value;
            } else
                result[key] = value;
        }

        for (const [arrayName, items] of Object.entries(arrays))
            result[arrayName] = items;

        return result;
    }
}
